import React from "react";
import { UserPlus } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge, Button, Card } from "../ui";

function CheckedInDancer({ dancer }) {
  const hidden = Boolean(dancer.hide_name);
  const displayName = hidden ? "Someone" : (dancer.name || "Someone");
  const initial = hidden ? "?" : (dancer.name?.slice(0, 1) || "?");
  const thumbnail = hidden ? null : dancer.thumbnail_url;

  return (
    <Card className="p-3">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full bg-pinky/60 overflow-hidden grid place-items-center font-ui font-semibold text-[17px] shrink-0 border border-black/[0.06]">
          {thumbnail ? (
            <img src={thumbnail} alt="" className="w-full h-full object-cover" />
          ) : (
            initial
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-ui font-semibold text-[16px] leading-tight truncate">
            {displayName}
          </p>
          <div className="mt-1 flex flex-wrap gap-1.5">
            {dancer.role && <Badge color="white">{dancer.role}</Badge>}
            {(dancer.dance_forms || []).slice(0, 3).map((df) => (
              <Badge key={df.name} color="sky">{df.name}</Badge>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
}

export default function CheckInFloorTab({
  showSignInPrompt,
  signInNext,
  checkedIn,
  /** @deprecated ignored — quiet language everywhere */
  variant: _variant = "sticker",
}) {
  return (
    <>
      {showSignInPrompt && (
        <Card className="p-5" data-testid="check-in-sign-in-prompt">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-full bg-canvas border border-black/[0.06] grid place-items-center shrink-0">
              <UserPlus className="w-6 h-6" strokeWidth={2} />
            </div>
            <div className="min-w-0 flex-1">
              <p className="font-ui font-semibold text-[20px] sm:text-[22px] leading-tight text-balance">Sign in so we remember you</p>
              <p className="mt-2 text-[14px] font-normal text-ink/65 leading-relaxed text-pretty">
                You&apos;re checked in on this device. Create a free account to keep your RSVPs, check-ins, and game votes — even if you switch phones.
              </p>
              <Link
                to={`/login?next=${encodeURIComponent(signInNext)}`}
                className="inline-block mt-4"
              >
                <Button variant="primary" size="lg" data-testid="check-in-sign-in-btn">
                  Sign in or sign up →
                </Button>
              </Link>
            </div>
          </div>
        </Card>
      )}

      <section>
        <p className="font-ui text-[12px] font-medium text-ink/50">
          Checked-in dancers
        </p>
        <h2 className="font-ui font-semibold text-[17px] sm:text-[18px] leading-tight mt-0.5">
          Who&apos;s on the floor
        </h2>
        <div className="mt-3 space-y-2" data-testid="checked-in-dancers">
          {checkedIn.map((dancer) => (
            <CheckedInDancer key={dancer.dancer_id} dancer={dancer} />
          ))}
        </div>
      </section>
    </>
  );
}
